<template>
  <!-- eslint-disable -->
  <div class="caseStudy view">
    <Header></Header>
    <div class="caseStudy__container layoutGrid">
      <h1 class="caseStudy__title h1">Hyperloop</h1>
      <p class="caseStudy__paragraph p">
        The Hyperloop is a proposed new form of transit with leverages vacuum tubes and magnetic levitation to achieve speeds over 700mph. The Carnegie Mellon Hyperloop team is a student organization which competes in the SpaceX Hyperloop Competition.
      </p>
      <p class="caseStudy__paragraph p">
        When I joined the team as Co-Design Lead Thomas Kelly and I set out to tell the story of the hyperloop in an unconventional way. Instead of focusing on the technology in the pod, or even how fast it would go, we wanted to tell a story about how it would help people.
      </p>
      <p class="caseStudy__paragraph p">
        Over a four week design / development process we created a virtual reality motion simulator, which we would use to tell that story. The final experience was part video narrative and part VR experience. The story brought the audience years into the future but grounded that experience in experiences we all already have.
      </p>
      <div class="video-container caseStudy__video">
        <iframe
          src="https://www.youtube.com/embed/rcD8MBQHjYY"
          frameborder="0"
          allow="autoplay; fullscreen"
          class="video-video"
          allowfullscreen
        />
      </div>
      <p class="caseStudy__paragraph p">
        Combining a digital world which kept a constant reference frame to the guest and the feeling of being pushed back into your seat, we let guests experience the gentle acceleration expected from the hyperloop.
      </p>
      <img
        src="@/assets/hyperloop/hl_01.jpg"
        alt="Image of the hyperloop virtual reality experience"
        class="caseStudy__image"
      />
      <p class="caseStudy__paragraph p">
        The ride was such a success at our 2017 pod reveal event that Volvo decided to sponsor us as part of their future showcase at ConExpo 2017 in Las Vegas, a week-long trade show. At that event several thousand people were able to experience our work. Since then the experience has been exhibited at four more events across the country.
      </p>
      <img
        src="@/assets/hyperloop/hl_02.jpg"
        alt="Image of the hyperloop virtual reality experience"
        class="caseStudy__image caseStudy__image--lowBottom"
      />
      <img
        src="@/assets/hyperloop/hl_03.png"
        alt="Image of the hyperloop virtual reality experience"
        class="caseStudy__image caseStudy__image--lowBottom caseStudy__image--lowTop"
      />
      <img
        src="@/assets/hyperloop/hl_04.jpg"
        alt="Image of the hyperloop virtual reality experience"
        class="caseStudy__image caseStudy__image--lowBottom caseStudy__image--lowTop"
      />
      <img
        src="@/assets/hyperloop/hl_05.jpg"
        alt="Image of the hyperloop virtual reality experience"
        class="caseStudy__image caseStudy__image--lowTop"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
export default {
  components: {
    Header
  }
};
</script>
